// extracted by mini-css-extract-plugin
export default {"dropdown":"style_dropdown__CUOuG","icon":"style_icon__lM0RL"};